import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { DynatraceService } from '../../libs/drrweb-lib/src/lib/shared/services/dynatrace.service'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [RouterOutlet],
})
export class AppComponent {
  constructor(private _: DynatraceService) {}
}
